import React, { useState, useEffect } from 'react'
import { getBreConfigData,saveUpdateBreconfigData } from '../../../../AdminActionCreator.component'
import Loader from '../../../../../../presentationals/Loader/Loader.component'

export default function CreditScoring({ allDetail, scoreDetail, viewType, changeViewState }) {
    const [loader, setLoader] = useState(false)
    const [apiData, setapiData] = useState({})
    const [updatedData, setUpdatedData] = useState([])
    const InputStyle = {
        border: "1px solid #1D3557",
        borderRadius: '8px',
        padding: "6px",
        width:"100%"
    }

    useEffect(() => {
        if (scoreDetail && scoreDetail?.length > 0) {
            setUpdatedData(scoreDetail)
        }
        if (viewType === "edit") {
            getBreConfigDataFunction()
        }
    }, [scoreDetail, viewType])

    const handlechange = (e, field, index) => {
       
        let newValue = e.target.value;


        if (field === "weightagePercentage") {
            // const newWeightage = newValue?.replace("%", "") || "";
            if (Number(field) > 100) {
                return
            } else {
                newValue = field + "%";
            }
        } else if (field === "score") {
            if (Number(newValue) > 100) {
                return
            } else {
                newValue = newValue;
            }
        }

        setUpdatedData(prevData => {
            const updatedArray = [...prevData];
            updatedArray[index] = { ...updatedArray[index], [field]: newValue };
            return updatedArray;
        });
    }


    const handleSave = () => {
        console.log("updatedDataupdatedData", updatedData)
        if (viewType === "edit") {
            setLoader(true)
            saveUpdateBreconfigData(allDetail?.userId,updatedData,(callback)=>{
                console.log("callback",callback)
                if(callback == "success"){
                    changeViewState()
                }else{

                }
                setLoader(false)
            })

        }
    }


    const getBreConfigDataFunction = () => {
        setLoader(true)
        getBreConfigData((callback) => {
            setLoader(false)
           
            setapiData(callback)
        })
    }


    return (
        <>
            <div className="" style={{ padding: '10px' }}>
                {
                    loader ?
                        <Loader /> : ''
                }
                <div style={{ background: '#DBE9FF', padding: '10px', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                    <b>BRE Scoring</b>
                </div>
                <div className="" style={{ overflow: 'auto',height:'710px' }}>
                    <table className="scoring-table" style={{ position: 'relative' }}>
                        <tr>
                            <td style={{ borderTop: 'none', whiteSpace: 'nowrap', position: 'sticky', left: '0', zIndex: '10', background: '#fff' }}><b>Policy Parameters</b></td>
                            <td style={{ borderTop: 'none', borderLeft: 'none', textAlign: 'center', whiteSpace: 'nowrap' }}><b>Score Parameters</b></td>
                            <td style={{ borderTop: 'none', borderLeft: 'none', textAlign: 'center', whiteSpace: 'nowrap' }}><b>Weightage (in %)</b></td>
                            <td style={{ borderTop: 'none', borderLeft: 'none', textAlign: 'center', whiteSpace: 'nowrap' }}><b>Score</b></td>
                        </tr>
                        {
                            updatedData && updatedData?.length > 0 ?
                                updatedData?.map((value, index) => {

                                    // const newWeightage = value?.weightage?.replace("%", "") || "";
                                    const arr = value?.["policyParameter"] == "OEM Name" ? apiData?.["OEM Name"] : value?.["policyParameter"] == "Dealer Name" ? apiData?.["Dealer Name"] : value?.["policyParameter"] == "Gender" ? apiData?.Gender : value?.["policyParameter"] == "Ownership Status" ? apiData?.["Ownership Status"] : value?.["policyParameter"] == "FOIR" ? apiData?.["FOIR"] : [];
                                    return (
                                        <tr key={index}>
                                            <td style={{ borderTop: 'none', whiteSpace: 'nowrap', position: 'sticky', left: '0', zIndex: '10', background: '#fff' }}>
                                                {value?.["policyParameter"] || ""}
                                            </td>
                                            <td style={{ borderTop: 'none', whiteSpace: 'nowrap', borderLeft: 'none', textAlign: 'center', padding: viewType === "edit" ? "8px" : "10px" }}>
                                                {
                                                    viewType === "edit" &&  value?.["policyParameter"] !== "Age" ?
                                                        value?.["policyParameter"] == "OEM Name" || value?.["policyParameter"] == "Gender" || value?.["policyParameter"] == "Dealer Name" || value?.["policyParameter"] == "Ownership Status" || value?.["policyParameter"] == "FOIR" ?
                                                            <select  value={value?.["scoreParameter"]} name={`${value?.["policyParameter"]}-scoreParameter`} style={InputStyle} onChange={(e) => handlechange(e, "scoreParameter", index)}>
                                                                <option value="">Select</option>
                                                                {
                                                              arr?.map((values,index)=>{
                                                               let vl = value?.["policyParameter"] == "Ownership Status" && values == "Owned" ? "Own" : values 
                                                                return(
                                                                    <>
                                                                    <option key={index} value={values}>
                                                                        {vl}
                                                                        </option>
                                                                    </>
                                                                )
                                                              })
                                                                 
                                                                }
                                                            </select>
                                                            :
                                                            <input type='text' value={value?.["scoreParameter"]} name={`${value?.["policyParameter"]}-scoreParameter`} style={InputStyle} onChange={(e) => handlechange(e, "scoreParameter", index)} />
                                                        :
                                                        value?.["scoreParameter"] || ""
                                                }
                                            </td>
                                            <td style={{ borderTop: 'none', whiteSpace: 'nowrap', borderLeft: 'none', textAlign: 'center' }}>
                                                {
                                                    viewType === "edit" &&  value?.["policyParameter"] !== "Age" ?
                                                        <input type='number' value={value?.weightagePercentage} name={`${value?.["policyParameter"]}-weightagePercentage`} min={0} max={100} style={InputStyle} onChange={(e) => handlechange(e, "weightagePercentage", index)} />
                                                        :
                                                        value?.weightagePercentage || ""
                                                }

                                            </td>
                                            <td style={{ borderTop: 'none', whiteSpace: 'nowrap', borderLeft: 'none', textAlign: 'center' }}>
                                                {
                                                    viewType === "edit" &&  value?.["policyParameter"] !== "Age" ?
                                                        <input type='number' value={value?.score} name={`${value?.["policyParameter"]}-score`} min={0} max={100} style={InputStyle} onChange={(e) => handlechange(e, "score", index)} />
                                                        :
                                                        value?.score || ""
                                                }

                                            </td>
                                        </tr>
                                    )
                                })
                                : ''}



                    </table>
                </div>
                {
                    viewType === "edit" ?
                        <div style={{ marginTop: '20px' }}>
                            <button className="btn-primary" style={{ borderRadius: '8px', border: '1px solid #064254' }} onClick={() => handleSave()}>Save</button>
                        </div>
                        : ''}
            </div>
        </>
    )
}
